export enum BillingNoticeSeverity {
    INFORMATION = 'information',
    WARNING = 'warning',
    CRITICAL = 'critical'
};
